<script>
import { inputErrorTypes } from "@/assets/JS/Validation.js";
import { MASTER } from "@/assets/JS/Master.js";

export default {
    name: "Statuses",
    props: {
        status: Object,
        submitted: Boolean,
        licenseNumber: Number
    },
    data: () => ({
        inputErrorTypes,
        MASTER
    }),
    methods: {
        ShowStatus: function () {
            return Object.keys(this.status).length && this.status.label !== inputErrorTypes.invalid;
        }
    }
};
</script>

<template>
    <div id="status" v-if="ShowStatus()">
        <div class="flex-center layout-50 m-row">

            <!-- Stamp; appears in top left of status -->
            <div id="stamp" class="single">
                <p><b>License Number:</b> {{ licenseNumber }}</p>
                <p v-if="status.issuedDate"><b>Issued:</b> {{ MASTER.FormatDate(status.issuedDate, "Full") }}</p>
                <div class="divider m-toggle"></div>
            </div>

            <div id="status-labels" class="align-r layout m-align-l m-no-pad m-span single">
                <p class="m-hide sub-status-label">Status</p>
                <p class="status-label">{{ status.label }}</p>
                <p class="status-date" v-if="status.date"><b>{{ MASTER.FormatDate(status.date, "Full") }}</b></p>
            </div>
            <div id="status-icon" class="layout m-align-c m-span" v-if="status.icon">
                <img :src="require(`@/assets/Images/${status.icon}`)" :alt="`Icon - ${status.label}`" :title="status.label" width="135" height="135"/>
            </div>
        </div>
        <p>{{ status.message }}</p>
    </div>
    <div v-if="status.error">
        <p class="alert">{{ status.message }}</p>
    </div>
</template>